import { pipe, prop } from 'ramda';

const selectAllVideoPrivacyState = prop('videoPrivacy');

export const selectVideoPrivacyModalIsShowing = pipe(
  selectAllVideoPrivacyState,
  prop('videoPrivacyModal'),
  prop<boolean>('isShowing')
);

export const selectShortcodeForVideoPrivacyModal = pipe(
  selectAllVideoPrivacyState,
  prop('videoPrivacyModal'),
  prop('shortcode')
);

export const selectVideoPrivacyResetModalIsShowing = pipe(
  selectAllVideoPrivacyState,
  prop('resetModal'),
  prop<boolean>('isShowing')
);

export const selectVideoPrivacyResetModalIsResetting = pipe(
  selectAllVideoPrivacyState,
  prop('resetModal'),
  prop<boolean>('isResetting')
);

export const selectVideoPrivacyAllowedDomainIsSaving = pipe(
  selectAllVideoPrivacyState,
  prop('videoPrivacyModal'),
  prop('allowedDomain'),
  prop<boolean>('isLoading')
);

export const selectVideoPrivacyAllowedDomainHasSaved = pipe(
  selectAllVideoPrivacyState,
  prop('videoPrivacyModal'),
  prop('allowedDomain'),
  prop<boolean>('isDone')
);
